import { SortDirection } from '../../../../../../general-types';
import { SCORING_RULE, ScoringRuleType } from '../../../../../constants/scoringRule';
import { LeaderboardListSortField } from '../../../../../interfaces/leaderboard/LeaderboardListFilters';

type SortOption = {
  label: string;
  fieldName: LeaderboardListSortField;
  direction: SortDirection;
};

const RANK_OPTION: SortOption = {
  label: 'Rank',
  fieldName: 'RANK',
  direction: 'ASC',
};

const FOOD_TRACKING_OPTION: SortOption = {
  label: 'Food Tracking',
  fieldName: 'FOOD_TRACKING_PERCENTAGE',
  direction: 'DESC',
};

const FAT_LOSS_OPTION: SortOption = {
  label: 'Fat Loss',
  fieldName: 'FAT_LOSS_PERCENTAGE',
  direction: 'DESC',
};

const MUSCLE_GAIN_OPTION: SortOption = {
  label: 'Muscle Gain',
  fieldName: 'MUSCLE_GAIN_LBS',
  direction: 'DESC',
};

export const SORT_OPTIONS_BY_SCORING_RULE: Record<ScoringRuleType, SortOption[]> = {
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN_FOOD_TRACKING]: [
    RANK_OPTION,
    FOOD_TRACKING_OPTION,
    FAT_LOSS_OPTION,
    MUSCLE_GAIN_OPTION,
  ],
  [SCORING_RULE.FAT_LOSS_MUSCLE_GAIN]: [RANK_OPTION, FAT_LOSS_OPTION, MUSCLE_GAIN_OPTION],
  [SCORING_RULE.FAT_LOSS]: [RANK_OPTION, FAT_LOSS_OPTION, MUSCLE_GAIN_OPTION],
};
